import { LoginRequest, AuthResponse } from '../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const formData = new URLSearchParams();
    formData.append('username', credentials.email);
    formData.append('password', credentials.password);

    const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

    try {
      // Use fetch instead of axios to avoid any interceptor issues
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      const responseData = await response.json();

      if (!response.ok) {
        console.error('Login error:', {
          status: response.status,
          statusText: response.statusText,
          data: responseData
        });
        throw new Error(responseData.detail || 'Login failed');
      }


      return responseData;
    } catch (error: any) {
      console.error('Login error details:', error);
      throw error;
    }
  },

  register: async (userData: { name: string; email: string; password: string }) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.detail || 'Registration failed');
      }


      return responseData;
    } catch (error: any) {
      console.error('Registration error:', error);
      throw error;
    }
  },

  getCurrentUser: async () => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('No token found');
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/me`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.detail || 'Failed to get current user');
      }

      return responseData;
    } catch (error: any) {
      console.error('Get current user error:', error);
      throw error;
    }
  },
};
